import React from "react";
import {Link} from "react-router-dom";

import {Td} from "../../atoms/tables/table";

type Props = {
    href: string;
    children: React.ReactNode;
};
const CategoryLinkCell = ({href, children}: Props) => {
    return (
        <Td>
            <Link style={{color: "#0095FF"}} to={href}>
                {children}件
            </Link>
        </Td>
    );
};

export default CategoryLinkCell;
